import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import M from "moment/moment";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import * as R from "ramda";
import DateRange from "../../../payment/common/dateRange";
import {defaultFilter} from "../config";
import {mapToObjectDDL} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import {
    loyaltyLevelOptions,
    memberLevelOptions,
    operatorOptions,
    prospekCategoryOptions,
    prospekSourceOptions,
    prospekTypeOptions,
    socMedOptions
} from "../../config/constants";
import { fetchDataAsync } from "../../../../../Services/Utils";

class CRMFollowUpFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: defaultFilter,
            prospekCategoryOptions: prospekCategoryOptions,
            prospekTypeOptions: prospekTypeOptions,
            prospekSourceOptions: prospekSourceOptions,
            operatorOptions: operatorOptions,
            provinceOptions: [],
            kabkotOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
            levelOptions: memberLevelOptions,
            loyaltyOptions: loyaltyLevelOptions,
            hobbyOptions: [],
            interestOptions: [],
            socMedOptions: socMedOptions,
            zipCodeRaw: [],
        };
    };

    componentDidMount() {
        if (!R.isEmpty(this.props.search)) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...defaultFilter,
                    ...this.props.search
                }
            }));
        }
        this.fetchDataProvince();
        this.fetchDataHobby();
        this.fetchDataInterest();
    };

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (prevState.filter?.province?.value !== this.state.filter?.province?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kabkot: prevState.filter?.province?.value ? {} : prevValue.filter.kabkot,
                    kecamatan: prevState.filter?.province?.value ? {} : prevValue.filter.kecamatan,
                    kelurahan: prevState.filter?.province?.value ? {} : prevValue.filter.kelurahan,
                    kodePos: prevState.filter?.province?.value ? {} : prevValue.filter.kodePos,
                },
                kecamatanOptions: [],
                kelurahanOptions: [],
                zipCodeOptions: [],
            }));
            if (!R.isNil(this.state.filter?.province)) await this.fetchDataKabKot(this.state.filter.province.value);
        }
        if (prevState.filter?.kabkot?.value !== this.state.filter?.kabkot?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kecamatan: prevState.filter?.province?.value ? {} : prevValue.filter.kecamatan,
                    kelurahan: prevState.filter?.province?.value ? {} : prevValue.filter.kelurahan,
                    kodePos: prevState.filter?.province?.value ? {} : prevValue.filter.kodePos,
                },
                kelurahanOptions: [],
                zipCodeOptions: [],
            }));
            if (!R.isNil(this.state.filter?.kabkot)) await this.fetchDataKecamatan(this.state.filter.kabkot.value);
        }
        if (prevState.filter?.kecamatan?.value !== this.state.filter?.kecamatan?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kelurahan: prevState.filter?.province?.value ? {} : prevValue.filter.kelurahan,
                    kodePos: prevState.filter?.province?.value ? {} : prevValue.filter.kodePos,
                },
                zipCodeOptions: [],
            }));
            if (!R.isNil(this.state.filter?.kecamatan)) await this.fetchDataKelurahan(this.state.filter.kecamatan.value);
        }
        if (prevState.filter?.kelurahan?.value !== this.state.filter?.kelurahan?.value && !R.isEmpty(this.state?.zipCodeRaw)) {
            const data = R.isNil(this.state.filter?.kelurahan) ? [] : this.state.zipCodeRaw.find(item => item.id === this.state.filter.kelurahan.value);
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kodePos: prevState.filter?.province?.value ? {} : prevValue.filter.kodePos,
                },
                zipCodeOptions: !R.isEmpty(data) ? [mapToObjectDDL(data?.zipcode, data?.zipcode)] : [],
            }));
        }
    };

    fetchDataHobby = async () => {
        try {
            const response = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
              setError: this.props.setError,
              menuName: "",
              args: { paramFilters: { bizparCategory: "HOBBY_TYPE" } },
            });
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    hobbyOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.value, item.key)
                    ),
                }))
                ;
            }
        } catch (e) {
            console.log("errors", e);
        }
    };
    
    fetchDataInterest = async () => {
        try {
            const response = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
              setError: this.props.setError,
              menuName: "",
              args: { paramFilters: { bizparCategory: "INTEREST_TYPE" } },
            });
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    interestOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.value, item.key)
                    ),
                }))
                ;
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataProvince = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    provinceOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.provinceName, item.id)
                    ),
                }))
                ;
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKabKot = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id)
            if (response.ok && response.data.data) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kabkotOptions: response.data.data?.map(item =>
                        mapToObjectDDL(item.kabKotName, item.kabKotId))
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKecamatan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id)
            if (response.ok && response.data.data) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kecamatanOptions: response.data.data?.map(item =>
                        mapToObjectDDL(item.kecamatanName, item.id))
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKelurahan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id)
            if (response.ok && response.data.data) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kelurahanOptions: response.data.data?.map(item =>
                        mapToObjectDDL(item.kelurahanname, item.id)
                    ),
                    zipCodeRaw: response.data.data,
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    handleReset = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: defaultFilter,
        }));
    };

    handleSubmit = () => {
        // if (JSON.stringify(defaultFilter) === JSON.stringify(this.state.filter)) {
        //     this.props.onSetState((prevValue) => ({
        //         ...prevValue,
        //         submittedFilter: {},
        //     }));
        // }
        this.props.onSubmit(this.state.filter);
    };

    onDateChange = (key, name, value) => {
        if (R.equals(name, "tanggalAkhir")
            && !R.isNil(this.state.filter[key]?.tanggalAwal)
            && M(value, "DD-MM-YYYY").isBefore(M(this.state.filter[key].tanggalAwal, "DD-MM-YYYY"))
        ) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    [key]: {
                        tanggalAwal: M(value).format("DD-MM-YYYY"),
                        tanggalAkhir: M(value).format("DD-MM-YYYY"),
                    }
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                [key]: {
                    ...prevValue.filter[key],
                    [name]: value,
                }
            }
        }));
    };

    setValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                [name]: value,
            }
        }))
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                styles={{width: "60%"}}
                content={
                    <ModalContainer>
                        {/* <SimpleInput
                            name="kodeCabang"
                            label="Kode Cabang"
                            value={this.state.filter.kodeCabang}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        /> */}
                        <div>
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>
                                    Overdue
                                </h4>
                            </div>
                            <FlexView style={{alignItems: "center", gap: "20px"}}>
                                <SimpleDDL
                                    box="search"
                                    id="select_options_operator"
                                    name="operator"
                                    options={this.state.operatorOptions}
                                    value={this.state.filter.operator}
                                    containerclassname="width width-250px"
                                    onChange={(value, {name}) => this.setValue(name, value)}
                                />
                                <SimpleInput
                                    box="onlyNumber"
                                    name="overdue"
                                    value={this.state.filter.overdue}
                                    onChange={({target}) => this.setValue(target.name, target.value)}
                                />
                                <div className="txt-site txt-12 txt-main txt-bold margin-bottom-20px">
                                    <h4>Days</h4>
                                </div>
                            </FlexView>
                        </div>
                        <DateRange
                            data={this.state.filter.tanggalProspek}
                            label="Tanggal Prospek"
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("tanggalProspek", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("tanggalProspek", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="prospectName"
                            label="Nomor Prospek"
                            value={this.state.filter.prospectName}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_category"
                            box="search"
                            name="prospectCategory"
                            label="Kategori Prospek"
                            options={this.state.prospekCategoryOptions}
                            value={this.state.filter.prospectCategory}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_type"
                            box="search"
                            name="prospectKind"
                            label="Jenis Prospek"
                            options={this.state.prospekTypeOptions}
                            value={this.state.filter.prospectKind}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_source"
                            box="search"
                            name="prospectSource"
                            label="Asal Prospek"
                            options={this.state.prospekSourceOptions}
                            value={this.state.filter.prospectSource}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleInput
                            name="sourceCabang"
                            label="Cabang Asal"
                            value={this.state.filter.sourceCabang}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="ownerProspect"
                            label="Pemilik Prospek"
                            value={this.state.filter.ownerProspect}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="lastSeller"
                            label="Penjual Terakhir"
                            value={this.state.filter.lastSeller}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <DateRange
                            data={this.state.filter.fuDate}
                            label="Last Follow Up Date"
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("fuDate", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("fuDate", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="lastFollowUpStatus"
                            label="Last Follow Up Status"
                            value={this.state.filter.lastFollowUpStatus}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="lastFollowUpBy"
                            label="Last Follow Up By"
                            value={this.state.filter.lastFollowUpBy}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <DateRange
                            data={this.state.filter.appointmentDate}
                            label="Next Appointment Date"
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("appointmentDate", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("appointmentDate", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="information"
                            label="Keterangan"
                            value={this.state.filter.information}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="nama"
                            label="Nama"
                            value={this.state.filter.nama}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="nik"
                            label="NIK"
                            value={this.state.filter.nik}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="handPhoneNumber"
                            label="No HP"
                            value={this.state.filter.handPhoneNumber}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="alamat"
                            label="Alamat"
                            value={this.state.filter.alamat}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_province"
                            box="search"
                            name="province"
                            label="Provinsi"
                            options={this.state.provinceOptions}
                            value={this.state.filter.province}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kabkot"
                            box="search"
                            name="kabkot"
                            label="Kota/Kabupaten"
                            options={this.state.kabkotOptions}
                            value={this.state.filter.kabkot}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kecamatan"
                            box="search"
                            name="kecamatan"
                            label="Kecamatan"
                            options={this.state.kecamatanOptions}
                            value={this.state.filter.kecamatan}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kelurahan"
                            box="search"
                            name="kelurahan"
                            label="Kelurahan"
                            options={this.state.kelurahanOptions}
                            value={this.state.filter.kelurahan}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_zip_code"
                            box="search"
                            name="kodePos"
                            label="Kode Pos"
                            options={this.state.zipCodeOptions}
                            value={this.state.filter?.kodePos}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleInput
                            name="memberId"
                            label="Member ID"
                            value={this.state.filter.memberId}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_member_level"
                            box="search"
                            name="memberLevel"
                            label="Member Level"
                            options={this.state.levelOptions}
                            value={this.state.filter.memberLevel}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_loyalty_level"
                            box="search"
                            name="loyaltyLevel"
                            label="Loyalty Level"
                            options={this.state.loyaltyOptions}
                            value={this.state.filter.loyaltyLevel}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_facebook"
                            box="search"
                            name="facebook"
                            label="Facebook"
                            options={this.state.socMedOptions}
                            value={this.state.filter.facebook}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_instagram"
                            box="search"
                            name="instagram"
                            label="Instagram"
                            options={this.state.socMedOptions}
                            value={this.state.filter.instagram}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_linkedin"
                            box="search"
                            name="linkedin"
                            label="LinkedIn"
                            options={this.state.socMedOptions}
                            value={this.state.filter.linkedin}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_twitter"
                            box="search"
                            name="x"
                            label="X (Twitter)"
                            options={this.state.socMedOptions}
                            value={this.state.filter.x}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_tiktok"
                            box="search"
                            name="tiktok"
                            label="TikTok"
                            options={this.state.socMedOptions}
                            value={this.state.filter.tiktok}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_hobby"
                            box="multiselect"
                            name="hobby"
                            label="Hobby"
                            options={this.state.hobbyOptions}
                            value={this.state.filter.hobby}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_interest"
                            box="multiselect"
                            name="interest"
                            label="Interest"
                            options={this.state.interestOptions}
                            value={this.state.filter.interest}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <FlexView style={{justifyContent: "center", marginTop: "20px", gap: "20px"}}>
                            <SimpleButton
                                onClick={this.handleReset}
                            >Reset</SimpleButton>
                            <SimpleButton
                                onClick={this.handleSubmit}
                            >Terapkan</SimpleButton>
                        </FlexView>
                    </ModalContainer>
                }
            />
        )
    }
}

export default CRMFollowUpFilter;
